import { SelectItem } from "@/components/select/types";
import { RoleEnum } from "@/store/user";
import { AdministratorCard } from "@/types/models/administrators";

export const validateAdministratorForm = (administrator: AdministratorCard, isAdministratorCreate = false) => {
    const COMPLETE_PHONE_LENGTH = 11;
    const errors: Partial<Record<keyof AdministratorCard, string>> = {};

    if (!administrator.name.length) {
        errors.name = 'Значение не должно быть пустым'
    }

    if (!administrator.patronymic.length) {
        errors.patronymic = 'Значение не должно быть пустым'
    }

    if (!administrator.surname.length) {
        errors.surname = 'Значение не должно быть пустым'
    }

    if (administrator.phone.length < COMPLETE_PHONE_LENGTH) {
        errors.phone = 'Введите номер телефона полностью';
    }
    
    if (!administrator.email.length) {
        errors.email = 'Значение не должно быть пустым'
    }

    if (!administrator.clinics.length && (`${administrator.role?.id}` as RoleEnum) === RoleEnum.ROLE_ADMIN) {
        errors.clinics = 'Значение не должно быть пустым'
    }

    if (administrator.password.length && administrator.password.length < 8) {
        errors.password = 'Минимальная длина пароля 8 символов'
    }
    
    if (isAdministratorCreate && !administrator.password.length) {
        errors.password = 'Значение не должно быть пустым'
    }

    if (administrator.password !== administrator.passwordConfirm) {
        errors.password = 'Значения не совпадают'
    }

    if (!administrator.role?.id) {
        errors.role = 'Выберите роль'
    }

    return errors;
}

export const prepareAdministratorData = (administrator: AdministratorCard, isCreateAdministrator = false) => {
    const data: Record<string, any> = {
        name: administrator.name,
        patronymic: administrator.patronymic,
        surname: administrator.surname,
        phone: administrator.phone,
        email: administrator.email,
        is_active: administrator.is_active,
        role: (administrator.role as SelectItem).id,
    };

    if (administrator.clinics.length) {
        administrator.clinics.forEach((clinic, index) => {
            data[`clinics[${index}]`] = clinic.id;
        });
    }

    if (isCreateAdministrator || administrator.password.length) {
        data.password = administrator.password;
        data.repeatPassword = administrator.passwordConfirm;
    }

    return data;
}